module.exports = __webpack_public_path__ + "img/apc-cards.fb03818f.jpg";